import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { Button } from "reactstrap";
import { apiDelete, apiPost, apiRequest } from "../../utils/request";
import {
  IsNullOrUndefined,
  TANK_ACTION_TYPE_DROPOFF,
  TANK_ACTION_TYPE_PICKUP,
} from "../../constants";
import LocationTankView from "./LocationTankView";

class LocationTanksView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      tanks: [],
      availableTanks: [],
      isOpen: false,
      selectedTank: null,
    };

    this.getTankColumns = this.getTankColumns.bind(this);
    this.handleTankAction = this.handleTankAction.bind(this);
    this.fetchAvailableTanks = this.fetchAvailableTanks.bind(this);
    this.fetchTanks = this.fetchTanks.bind(this);
    this.handleDeleteRequest = this.handleDeleteRequest.bind(this);
    this.handleNew = this.handleNew.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.handleSelectEdit = this.handleSelectEdit.bind(this);
  }

  fetchAvailableTanks() {
    apiRequest("/api/tanks/toassign").then((x) => {
      this.setState({
        availableTanks: x.data.map((y) => {
          return {
            value: [y.tankSizeId, y.tankAssetTypeId],
            label: `${y.name} (${y.available} available, ${y.incompleteRequestCount} requests)`,
            name: `${y.name} (${y.available} available, ${y.incompleteRequestCount} requests)`,
            hasHeater: y.hasHeater,
            tankAssetTypeId: y.tankAssetTypeId,
            tankSizeId: y.tankSizeId,
          };
        }),
      });
    });
  }

  fetchTanks() {
    let { locationId } = this.props;

    this.setState({ selectedTank: null, tanks: [] }, () => {
      apiRequest(`/api/managelocations/${locationId}/tanks`).then((x) => {
        this.setState({ tanks: Array.from(x.data) });
      });
    });
  }

  handleNew() {
    this.setState({
      selectedTank: {
        tankSizeId: null,
        hasHeater: false,
        tankAlreadyAtLocation: true,
      },
      isOpen: true,
    });
  }

  cancelEdit() {
    this.setState({
      isOpen: false,
      selectedTank: null,
    });
  }

  handleDeleteRequest(x) {
    let { locationId } = this.props;

    apiDelete(
      `/api/managelocations/${locationId}/tanks/deleteTankRequest`,
      x,
      false
    ).then((_) => {
      this.fetchTanks();
      this.fetchAvailableTanks();
    });
  }

  handleSelectEdit(e, item) {
    e.preventDefault();
    this.setState({ selectedTank: item, isOpen: true });
  }

  handleTankAction(tank, action) {
    let { locationId } = this.props;

    let postData = {
      tankSizeId: tank.tankSizeId,
      hasHeater: tank.hasHeater,
      locationId,
      action,
      tankId: tank.tankId,
      tankAlreadyAtLocation: tank.tankAlreadyAtLocation,
      tankAssetTypeId: tank.tankAssetTypeId,
    };
    apiPost(
      `/api/managelocations/${locationId}/tanks/createTankRequest`,
      postData,
      false
    ).then((_) => {
      this.fetchTanks();
      this.fetchAvailableTanks();
    });
  }

  /*

    Change to:
    
    TankName
    TankAssignedToLocation
    tankRequestActionString
    IsTankRequestComplete

 */

  getTankColumns() {
    return [
      {
        id: "tank",
        accessor: (x) => (
          <a href={""} onClick={(e) => this.handleSelectEdit(e, x)}>
            {x.tankName}
          </a>
        ),
        Header: "Tank",
      },
      {
        id: "tankRequestHasHeater",
        Header: "Has Heater",
        accessor: (x) =>
          IsNullOrUndefined(x.tankRequestId)
            ? x.tankHasHeater
            : x.tankRequestHasHeater,
        Cell: (row) => (
          <div style={{ textAlign: "center" }}>
            {row.value ? (
              <i className={"fa fa-check"} />
            ) : (
              <i className={"fa fa-times"} />
            )}
          </div>
        ),
        maxWidth: 100,
      },
      {
        id: "tankAssignedToLocation",
        Header: "At Location",
        accessor: (x) => x.tankAssignedToLocation,
        Cell: (row) => (
          <div style={{ textAlign: "center" }}>
            {row.value ? (
              <i className={"fa fa-check"} />
            ) : (
              <i className={"fa fa-times"} />
            )}
          </div>
        ),
        maxWidth: 100,
      },
      {
        id: "tankRequestActionString",
        Header: "Action",
        accessor: (x) => x.tankRequestActionString,
        maxWidth: 100,
      },
      {
        id: "isTankRequestComplete",
        Header: "Complete",
        accessor: (x) => x.isTankRequestComplete,
        Cell: (row) => (
          <div style={{ textAlign: "center" }}>
            {row.value ? (
              <i className={"fa fa-check"} />
            ) : (
              <i className={"fa fa-times"} />
            )}
          </div>
        ),
        maxWidth: 100,
      },
    ];
  }

  componentDidMount() {
    this.fetchAvailableTanks();
    this.fetchTanks();
  }

  render() {
    let { tanks, selectedTank, availableTanks, isOpen } = this.state;

    return (
      <div
        style={{ border: "2px solid gray", padding: "5px", marginTop: "25px" }}
      >
        <LocationTankView
          isOpen={isOpen}
          onNewRequest={(tank) =>
            this.handleTankAction(tank, TANK_ACTION_TYPE_DROPOFF)
          }
          onDeleteRequest={this.handleDeleteRequest}
          onPickupRequest={(tank) =>
            this.handleTankAction(tank, TANK_ACTION_TYPE_PICKUP)
          }
          onCancel={this.cancelEdit}
          availableTanks={availableTanks}
          tank={selectedTank}
        />

        <div className="form-group row" style={{ marginTop: "30px" }}>
          <div className={"col-12"}>
            <h6>
              Tank Assignment
              <Button
                color="success"
                onClick={this.handleNew}
                className={"ml-2"}
              >
                <i className="fa fa-plus" />
                &nbsp;&nbsp;Add
              </Button>
            </h6>
          </div>
        </div>

        {/* isSuperUser && <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="locationTypeUniqueCode">New Tank Assignment</label>
                <div className="col-md-8 col-sm-12 col-xs-12">
                    <Select
                        name="tanks"
                        value={selectedTank}
                        multi={false}
                        clearable={true}
                        simpleValue={false}
                        options={availableTanks}
                        onChange={(val) => this.setState({selectedTank: val})}
                    />
                </div>
                <div className="col-md-2">
                    <Button color="primary" onClick={this.handleAssignTank} disabled={IsNullOrUndefined(selectedTank)}>Request Assignment</Button>
                </div>
            </div> */}

        <ReactTable
          sortable={true}
          filterable={false}
          showPagination={tanks.length > 20}
          data={tanks}
          columns={this.getTankColumns()}
          minRows={2}
        />
      </div>
    );
  }
}

LocationTanksView.propTypes = {
  locationId: PropTypes.number.isRequired,
  isSuperUser: PropTypes.bool,
};

export default LocationTanksView;
